<template>
  <div
    class="wt-tags-list-item"
    :class="{
      'tag-display-none': shouldHideTag,
    }"
    @click.stop
  >
    <span :title="showTitle ? tag.label : ''">{{ tag.label }}</span>
    <i
      class="tag-close wticon wticon-close"
      @click="onRemove($event, tag.id)"
    ></i>
  </div>
</template>

<script>
/**
 * wt-tags-list-item Vue component
 * no css except for functional ones ie: tag-display-none
 * define css nested ins parent container
 */
export default {
  props: {
    tag: {
      type: Object,
      require: true,
    },

    onRemove: {
      type: Function,
      require: true,
    },

    shouldHideTag: {
      type: Boolean,
      default: false,
    },

    showTitle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
